import React, { Component } from 'react';

export default class FindOrder extends Component {
  render() {
    return <div>Find Order</div>;
  }
}
